<template>
  <v-container grid-list-md fluid>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap align-center justify-center>
          <v-flex xs12 sm7>
            <span class="headline">Movimentações do Rebanho</span>
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn block color="primary" @click="create">
              {{ this.translate("system.button.manage.title") }}
              <v-icon dark right>{{ this.translate("system.button.manage.icon") }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm1>
            <v-menu offset-y>
              <v-btn slot="activator" icon class="ml-2" title="Relatórios">
                <v-icon>description</v-icon>
              </v-btn>
              <v-list>
                <!-- PDF -->
                <v-list-tile @click="exportReport(1)">
                  <v-list-tile-action>
                    <v-icon color="red darken-1">picture_as_pdf</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em PDF</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <!-- Excel -->
                <v-list-tile @click="exportReport(2)">
                  <v-list-tile-action>
                    <v-icon color="green darken-2">table_chart</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em Excel</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="items"
              class="elevation-1"
              rows-per-page-text="Registros por página"
              :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
              no-data-text="Não existem registros"
              no-results-text="Nenhum registro encontrado"
            >
              <template slot="items" slot-scope="props">
                <td class="subheading">{{ especie[props.item.especie - 1] }}</td>
                <td class="text-xs-right">{{ props.item.estoque_inicial }}</td>
                <td class="text-xs-right">{{ props.item.aquisicao }}</td>
                <td class="text-xs-right">{{ props.item.nascimento }}</td>
                <td class="text-xs-right">{{ props.item.consumo_e_perda }}</td>
                <td class="text-xs-right">{{ props.item.venda }}</td>
                <td class="text-xs-right">
                  {{
                    props.item.estoque_inicial +
                    props.item.aquisicao +
                    props.item.nascimento -
                    props.item.consumo_e_perda -
                    props.item.venda
                  }}
                </td>
              </template>
              <template slot="pageText" slot-scope="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">Gerenciamento de Movimentações do Rebanho</span>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="editedItem"
                  :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="subheading">{{ especie[props.item.especie - 1] }}</td>
                    <td>
                      <p-money
                        name="estoque_inicial"
                        class="custon-input"
                        :custom_precision="0"
                        v-model="props.item.estoque_inicial"
                        custom-preffix=""
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="aquisicao"
                        class="custon-input"
                        :custom_precision="0"
                        v-model="props.item.aquisicao"
                        custom-preffix=""
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="nascimento"
                        class="custon-input"
                        :custom_precision="0"
                        v-model="props.item.nascimento"
                        custom-preffix=""
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="consumo_e_perda"
                        class="custon-input"
                        :custom_precision="0"
                        v-model="props.item.consumo_e_perda"
                        custom-preffix=""
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="venda"
                        class="custon-input"
                        :custom_precision="0"
                        v-model="props.item.venda"
                        custom-preffix=""
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="aquisicao"
                        class="custon-input"
                        :custom_precision="0"
                        custom-preffix=""
                        disabled
                        :value="
                          Number(
                            props.item.estoque_inicial +
                              props.item.aquisicao +
                              props.item.nascimento -
                              props.item.consumo_e_perda -
                              props.item.venda
                          )
                        "
                      ></p-money>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  class="mx-1"
                  color="primary darken-2"
                  :disabled="saving"
                  :loading="saving"
                  @click.native="save('movimentacaorebanho')"
                >
                  Salvar
                </v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PMoney from "../shared/PMoney";
import crud from "./../../mixin/crud";

export default {
  components: { PMoney },
  mixins: [crud],
  data: () => ({
    entity: "condominio_movimentacaorebanho",
    especie: [
      "Bonivos e bufalinos",
      "Suínos",
      "Caprinos e ovinos",
      "Asininos, equinos e muares",
      "Outras",
    ],
    items: [],
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
  }),
  name: "MovimentacaoRebanho",
  props: ["condominio_id", "values"],
  created() {
    this.values.condominio_id = this.condominio_id;
    this.items = JSON.parse(JSON.stringify(this.values));
    this.editedItem = JSON.parse(JSON.stringify(this.items));
    this.defaultItem = JSON.parse(JSON.stringify(this.editedItem));
  },
  methods: {
    save() {
      if (this.saving) return;
      this.saving = true;
      this.$http.put("api/movimentacaorebanho/update_many", this.editedItem).then(
        (res) => {
          this.items = res.body;
          this.editedItem = JSON.parse(JSON.stringify(this.items));
          this.saving = false;
        },
        (err) => {
          this.saving = false;
          alert("Erro! Falha ao enviar a requisição.");
          console.log(err);
        }
      );

      this.dialog = false;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(() => {
        this.editedIndex = -1;
        this.view = 1;
      }, 400);
    },
    // type 1 = pdf 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`report/report_details/${this.condominio_id}`, {
        "type": type,
        "table": "condominio_movimentacaorebanho"
      }).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          const _this = this;
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.especie"),
          sortable: false,
          value: "especie",
        },
        {
          text: this.translate("table." + this.entity + ".field.estoque_inicial"),
          sortable: false,
          value: "estoque_inicial",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.aquisicao"),
          sortable: false,
          value: "aquisicao",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.nascimento"),
          sortable: false,
          value: "nascimento",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.consumo_e_perda"),
          sortable: false,
          value: "consumo_e_perda",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.venda"),
          sortable: false,
          value: "venda",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.resultado"),
          sortable: false,
          value: "resultado",
          align: "right",
        },
      ];
    },
  },
};
</script>

<style scoped>
.custon-input {
  outline-width: 0;
  height: 30px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid #949494;
  width: 100%;
}

tbody tr:nth-child(odd) {
  background: #e8f5e9;
}
</style>



// WEBPACK FOOTER //
// src/components/details/MovimentacaoRebanho.vue